export const SliderUtilReorder = (toRight: boolean, track: any, reorder?: boolean) => {
  let lowestOrder: any = null;
  let highestOrder: any = null;
  let reorderIndex = 1;
  track.childNodes.forEach((el: HTMLElement) => {
    if (!el?.style) {
      return;
    }
    if (reorder) {
      lowestOrder.style.order = reorderIndex;
      reorderIndex++;
      return;
    }
    if (!lowestOrder || !highestOrder) {
      lowestOrder = el;
      highestOrder = el;
    } else {
      if (parseInt(lowestOrder.style.order, 10) > parseInt(el.style.order, 10)) {
        lowestOrder = el;
      }
      if (parseInt(highestOrder.style.order, 10) < parseInt(el.style.order, 10)) {
        highestOrder = el;
      }
    }
  });
  if (toRight && !reorder) {
    lowestOrder.style.order = `${parseInt(highestOrder.style.order, 10) + 1}`;
  } else {
    highestOrder.style.order = `${parseInt(lowestOrder.style.order, 10) - 1}`;
  }
};

export const SliderUtilUpdateNavigation = (maxSize: number, size: number, activeIndex: number) => {
  return (el: HTMLElement, index: number) => {
    const classList = el.classList;
    if (!classList || maxSize <= size * 2 + 1) {
      return;
    }
    el.classList.remove('xxs');
    el.classList.remove('xs');
    if (activeIndex > index) {
      if (activeIndex === maxSize || activeIndex === maxSize - 1) {
        if (index === maxSize - (size * 2 + 1)) {
          el.classList.add('xs');
        } else if (index < maxSize - (size * 2 + 1)) {
          el.classList.add('xxs');
        }
      } else if (activeIndex >= size) {
        if (index === activeIndex - (size + 1)) {
          el.classList.add('xs');
        } else if (index < activeIndex - (size + 1)) {
          el.classList.add('xxs');
        }
      }
    } else {
      if (activeIndex - size <= 0) {
        if (index === size * 2 + 1) {
          el.classList.add('xs');
        } else if (index > size * 2 + 1) {
          el.classList.add('xxs');
        }
      } else if (activeIndex <= maxSize - size * 2) {
        if (index === activeIndex + size + 1) {
          el.classList.add('xs');
        } else if (index > activeIndex + size + 1) {
          el.classList.add('xxs');
        }
      } else if (activeIndex <= maxSize - (size * 2 - 1)) {
        if (index === activeIndex + size + 1) {
          el.classList.add('xs');
        }
      }
    }
  };
};
